<template>
  <section>
    <!--工具条-->
    <el-col :span="4" class="toolbar">
      <el-button type="primary" size="small" @click="addHandler">新增</el-button>
    </el-col>
  
    <el-col :span="6" class="toolbar rightsearch">
      <el-input placeholder="搜索" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button>
      </el-input>
    </el-col>
    <el-table :data="tableData" border v-loading="listLoading">
          <el-table-column label="编号" prop="sec_id" align="center">
      </el-table-column>
      <el-table-column label="一级分类名" prop="fname" align="center">
      </el-table-column>
      <el-table-column label="二级分类名" prop="sec_name" align="center">
      </el-table-column>
      <el-table-column label="操作" prop="labels" align="center">
        <template scope="scope">
          <el-button size="small" type="primary"  @click="editHandler(scope.row)">修改</el-button>
          <el-button v-if="scope.row.status == 0"  size="small" type="primary"  @click="deleteHandler(scope.row)">删除</el-button>
        <el-button v-if="scope.row.status == 1" size="small" type="primary"  @click="deleteHandler(scope.row)">恢复</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible">
      <el-form :model="addForm" label-width="150px" :rules="formRules" ref="addForm">
        <el-form-item label="一级分类名称" prop="fid">
          <el-select v-model="addForm.fid" placeholder="请选择">
            <el-option
              v-for="item in firstMenu"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分类名称" prop="sec_name">
          <el-input v-model="addForm.sec_name" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="分类图片" prop="pic">
          <el-upload
            class="avatar-uploader"
            action="https://up.qbox.me"
            :show-file-list='showUploadList'
            :on-success="handleSuccess"
            :on-error="handleError"
            :before-upload="beforeUpload"
            :data='uploadForm'>
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible">
      <el-form :model="editForm" label-width="150px" :rules="formRules" ref="editForm">
        <el-form-item label="一级分类名称" prop="fid">
          <el-select v-model="editForm.fid" placeholder="请选择">
            <el-option
              v-for="item in firstMenu"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分类名称" prop="sec_name">
          <el-input v-model="editForm.sec_name" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="分类图片" prop="pic">
          <el-upload
            class="avatar-uploader"
            action="https://up.qbox.me"
            :show-file-list='showUploadList'
            :on-success="handleSuccess"
            :on-error="handleError"
            :before-upload="beforeUpload"
            :data='uploadForm'>
            <img v-if="imageUrl" :src="imageUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
  import config from '../../config';
  import {
    getQiniuToken
  } from '../../static/js/token.js'
  import basicdata from '../../static/config/basicdata.js';
  import {
    formatDate
  } from '../../static/js/date.js';
  import {
    formatPara
  } from '../../static/js/util.js';
  
  export default {
    data() {
      return {
        tableData: [],
        total: 0,
        page: 1,
        pageSize: 15,
        listLoading: false,
        query: '',
        submitLoading: false,
        addFormVisible: false,
        addForm: {
          fid: '',
          sec_name: '',
          pic: '',
          status: 0
        },
        editFormVisible: false,
        editForm: {},
        formRules: {},
        firstMenu: [],
        showUploadList: false,
        uploadForm: {
          token: getQiniuToken(),
          key: null
        },
        imageUrl: '',
      }
    },
    methods: {
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getSearch(this.query);
      },
      getSearch(query) {
        this.listLoading = true;
        this.$axios.post(config.api_url + '/secondmenu/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if (data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'warning'
          });
        })
      },
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = Object.assign({}, this.addForm);
              para.pic = this.imageUrl;
              //异步请求
              this.$axios.post(config.api_url + '/secondmenu',
                para).then(response => {
                if (response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['addForm'].resetFields();
                  this.addFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      //操作删除
      deleteHandler(row) {
      let text = '是否删除？';
        let status = 1;
        if(row.status == 1) {
          text = '是否恢复？'
          status = 0
        }
    
          this.$confirm(text, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$axios.delete(config.api_url + '/secondmenu/delete/' + row.sec_id + '/' + status).then(response => {
              if (response.data.state) {
                 this.$message({
                message: '操作成功',
                type: 'success'
              });
                this.search();
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                });
              }
            }).catch(error => {
              this.$message({
                message: '删除异常，请联系管理员',
                type: 'error'
              });
            });
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        
      },
      //修改数据弹框
      editHandler(row) {
        this.editFormVisible = true;
        this.editForm = row
        this.imageUrl = row.pic;
      },
      editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = Object.assign({}, this.editForm);
              para.pic = this.imageUrl;
              //异步请求
              this.$axios.put(config.api_url + '/secondmenu',
                para).then(response => {
                if (response.data.state) {
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'error'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      addHandler() {
        this.addFormVisible = true;
        this.imageUrl = '';
      },
      getFirstMenu() {
        this.$axios.get(config.api_url + '/menu/tree').then(response => {
          let data = response.data;
          if (data && data.length > 0) {
            for (const item of data) {
              this.firstMenu.push({
                label: item.fname,
                value: item.fid
              });
            }
          } else {
            this.$message({
              message: '获取一级分类失败',
              type: 'error'
            });
          }
        }).catch(error => {
          this.$message({
            message: '获取一级分类异常，请联系管理员',
            type: 'error'
          });
        });
      },
      beforeUpload(file) {
        let fileName = 'secmenu/' + formatDate(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
        let mime = file.name.split('.')[1];
        fileName += '.' + mime;
        this.uploadForm.key = fileName;
      },
      handleSuccess(response, file, fileList) {
        this.imageUrl = basicdata.picUrl + this.uploadForm.key
        this.result = '上传成功'
      },
      handleError(error, response, file) {
        this.result = error.toString()
      },
    },
    created() {
      this.search();
      this.getFirstMenu();
    }
  }
</script>

<style scoped>
  .rightsearch {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// secmenu.vue?afbd771c